export default "__VITE_ASSET__LsvRgCih__"